import classNames from 'classnames';

const ButtonLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({
  children,
  className,
  ...otherProps
}) => {
  return (
    <a
      className={classNames(
        'min-h-10 rounded-md leading-4 px-4 py-3 bg-blue-300 text-white text-center font-sans font-bold',
        className
      )}
      {...otherProps}>
      {children}
    </a>
  );
};

export default ButtonLink;
